import { render } from "./Department.vue?vue&type=template&id=0aa9d4bf&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"

import "./Department.vue?vue&type=style&index=0&id=0aa9d4bf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0aa9d4bf"

export default script